import { makeSelectors } from '@utils/css';

const transitionDurationMs = 250;
const modifiers = makeSelectors({
  forwards: "_275f1aiyj0f",
  backwards: "_275bb11zmf"
});
const modal = "_275m11m7k0x";
const transitionGroup = "_275t5rwknj";
const section = "_275s1qrm96a";
const header = "_275hcwytyl";
const heading = "_275h1er4az9";
const contentWrapper = "_275ci5dspq";
const navButton = "_275n112im72";
const chevronWrapper = "_275ci3xks0";
const infoTextWrapper = "_275i1guqp37";
const infoText = "_275i1wtoi44";
const date = "_275d1vg1m17";
const closeButtonWrapper = "_275c16ydd9g";
const closeButton = "_275c1bdrtno";
const iframe = "_275ithvcyx";

export { chevronWrapper, closeButton, closeButtonWrapper, contentWrapper, date, header, heading, iframe, infoText, infoTextWrapper, modal, modifiers, navButton, section, transitionDurationMs, transitionGroup };
import "./modal.preview.style.linaria.module.css";
//# sourceMappingURL=modal.preview.style.js.map
